/**
 * OWLY CRM - Clientes Leads Data
 * Leads con stage >= 4 (convertidos a clientes)
 */

import { Lead } from '@/types';
import { mockProjects, getUnitDisplay } from '../../projects';

const torreVerdeUnits = mockProjects[0].units;
const bosquesRioUnits = mockProjects[1].units;
const ciudadJardinUnits = mockProjects[2].units;

export const clientesLeads: Lead[] = [];
